// Document ready
$(window).on('load', function() {

    $('.slider-le-4').slick({
        responsive: [
            {
                breakpoint: 5000,
                settings: 'unslick'
            },
            {
                breakpoint: 798,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            }
        ]
    });

    $('.slider-gt-4').slick({
        dots: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 798,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            }
        ]
    });

    $('.gift-options').each(function() {
      var $container = $(this);
      var $slider = $container.find('.slider-gt-3');
      if ($slider.length) {
        $slider.slick({
            dots: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: $container.find('.prev-arrow'),
            nextArrow: $container.find('.next-arrow'),
            responsive: [
                {
                    breakpoint: 798,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 2,
                        infinite: false,
                        dots: false
                    }
                }
            ]
        });
      }
    });

    $('.bundle-highlights .slider-gt-2').slick({
        responsive: [
            {
                breakpoint: 5000,
                settings: 'unslick'
            },
            {
                breakpoint: 798,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });


    $('.product-columns-wrapper.slider-gt-1').slick({
        responsive: [
            {
                breakpoint: 5000,
                settings: 'unslick'
            },
            {
                breakpoint: 798,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });

    $('.gallery-author-slider').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('.slider-image-with-text').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    (function() {
      const menu = document.querySelector('.sticky-menu-wrapper.sticky-menu-mobile-scroll');
      if (!menu) return;

      let touchStartX = 0;
      let scrollStartLeft = 0;
      let isScrolling = false;

      menu.addEventListener('wheel', (event) => {
        const isAtLeft = menu.scrollLeft <= 0;
        const isAtRight = menu.scrollLeft + menu.clientWidth >= menu.scrollWidth - 1;
        
        if ((event.deltaY > 0 && !isAtRight) || (event.deltaY < 0 && !isAtLeft)) {
          event.preventDefault();
          menu.scrollLeft += event.deltaY;
        }
      });

      menu.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        scrollStartLeft = menu.scrollLeft;
        isScrolling = true;
      });

      menu.addEventListener('touchmove', (e) => {
        if (!isScrolling) return;
        
        const touchX = e.touches[0].clientX;
        const diffX = touchStartX - touchX;
        
        menu.scrollLeft = scrollStartLeft + diffX;
        
        if (Math.abs(diffX) > 5) {
          e.preventDefault();
        }
      });

      menu.addEventListener('touchend', () => {
        isScrolling = false;
      });
    })();

    function isHighVolumeOrder() {
      if ($('.cart_subtotal .money').eq(0).length > 0) {
        var total = $('.cart_subtotal .money').eq(0).text();
      } else {
        var total = $('.cart_subtotal .right').eq(0).text();
      }
      total = parseFloat(total.replace(/[^0-9.]/g, ''));
      if (total > 0 && total > 5000) {
        return true;
      } else {
        return false;
      }
    }
    if (isHighVolumeOrder()) {
      $('.add_to_cart').html('Bulk Order - Please Contact Us');
      $('.additional-checkout-buttons').hide();
    }
    $('#checkout').on('click', function(event) {
      if (isHighVolumeOrder()) {
        if (!$('#high-volume-order').is(':visible')) {
          $.fancybox.open({
            src  : '#high-volume-order',
            type : 'inline'
          });
        }
        event.preventDefault();
        return false;
      }
    });

});

window.upcartOnCartLoaded = function() {
	jQuery('.upcart-product-item').each(function(e, i) {
		var $this = jQuery(this);
		var variant_id = $this.attr('id').split(':')[0];
		if (window.global_edd[variant_id]) {
      if ($this.find('.upcart-item-properties-anchor-before').length == 0) {
        $this.find('[class^="styles_BundleProperties__ColumnContainer"] > div:first').after('<div class="upcart-item-properties-anchor-before"></div>');







      }
      $this.find('.upcart-item-properties-anchor-before').html(window.global_edd[variant_id]);
    } else {
      $this.find('.upcart-item-properties-anchor-before').html();
    }
	});
}































// Upcart Tooltip to on click
$(document).on('click', '.tandcpop > p', function (e) {
	$.fancybox.open($('.tandcpop .tandcpoptext').html());
});

const myHandleAnimationIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    entry.target.classList.toggle('my-is-animated', entry.isIntersecting);
    if (entry.isIntersecting && entry.target.hasAttribute('data-once')) {
      observer.unobserve(entry.target);
    }
  });
};

const myAnimateElements = (wrapper = document) => {
  const animatedElements = wrapper.querySelectorAll('[my-data-animate]');

  /**
   * Attach observer.
   */
  animatedElements.forEach((element) => {
    const options = {
      rootMargin: element.hasAttribute('data-margin') ? element.getAttribute('data-margin'): '100% 0px 0px 0px',
      threshold: 0.2,
    };
    const observer = new IntersectionObserver(myHandleAnimationIntersection, options)
    
    observer.observe(element);
  });
}

/**
 * Animate elements.
 */
myAnimateElements();
